import { Component, inject, Sanitizer } from '@angular/core';
import { AuthenticationService } from '../shared/services/authentication.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent, ConfirmDialogData } from '../shared/components/confirm/confirm.component';
import { DomSanitizer } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from '../shared/services/notification.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {

  private readonly _auth = inject(AuthenticationService);
  private readonly _router = inject(Router);
  public readonly dialog = inject(MatDialog);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly notificationSvc = inject(NotificationService);
  public readonly user$ = this._auth.currentUser$;

  //  Needed for acceptance in the IOS app store
  public async delete(): Promise<boolean> {
    console.log('🔍 Delete Account');
    try {
      const areYouSureDialogData: ConfirmDialogData = {
        title: 'Are you sure you would like to delete your account?',
        message: this.sanitizer.bypassSecurityTrustHtml(`
          <p>Due to Medicare, Medicaid, and other social service regulations,
          we are required to retain ride records and user history for up to 7 years for audit and compliance purposes.</p>
          <p>Your account will be deactivated and removed from active use,
          and all non-required personal information will be deleted.</p>
        `),
        confirmLabel: 'Delete Account',
      };
      const _areYouSureDialog = this.dialog.open(ConfirmComponent, { data: areYouSureDialogData });
      const res = await firstValueFrom(_areYouSureDialog.afterClosed());
      if (!res) { return false; }

      await this._auth.lockoutUser();

      const _requestReceivedDialogData: ConfirmDialogData = {
        title: 'Request Received',
        message: this.sanitizer.bypassSecurityTrustHtml(`
          <p>We\’ve received your request.<p>
          <p>Our team will process it and retain only legally required information.</p>
        `),
        hideCancel: true,
        confirmLabel: 'OK',
      };
      this.dialog.open(ConfirmComponent, { data: _requestReceivedDialogData });
      return this._router.navigate(['/logout']);
    } catch (err) {
        console.error(err);
        if (err.message === 'test-account') { this.notificationSvc.error(`
          This is a test account specifically made for the purpose of testing in the App and Play Stores. It cannot be deleted.
          Regular user created accounts do not have such restrictions.`,
          'Ok',
        );
      } else {
        console.error(err);
        this.notificationSvc.error('An error has occurred attempting to request account deletion, please contact support for assistance');
      }
      return false;
    }
  }

}
